import type { ValidatorType } from "shelving";
import { BOOLEAN, DATA, INTEGER, KEY, pickProps } from "shelving";
import { KEYWORD_FIELDS } from "../util/keyword.js";
import { PRIVACY } from "../util/privacy.js";
import { CREATOR_ENTITY, ENTITIES } from "./entity.js";
import { ABOUT, NAME } from "./misc.js";

export const LISTS_MAX = 20;

export const LIST_SCHEMA = DATA({
	creator: CREATOR_ENTITY,
	verified: BOOLEAN,
	slug: KEY, // Path segment shown in the URL based on the title, e.g. `buy-now`
	name: NAME,
	privacy: PRIVACY,
	about: ABOUT,
	tags: ENTITIES,
	...KEYWORD_FIELDS,
	// List.
	items: ENTITIES, // List links controlled with `addListLink()` and `removeListLink()` APIs.
	// Dates.
	created: INTEGER,
	updated: INTEGER,
	// Counts.
	reactions: INTEGER,
});
export type ListData = ValidatorType<typeof LIST_SCHEMA>;

export const LIST_FORM_SCHEMA = DATA(pickProps(LIST_SCHEMA.props, "creator", "name", "about", "privacy"));
export type ListFormSchema = ValidatorType<typeof LIST_FORM_SCHEMA>;
